import React from "react";

import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import SplashLoader from "../SplashLoader"; // Nova Logo Splash Animada

const useStyles = makeStyles((theme) => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: theme.palette.type === "dark" ? "#fff" : theme.palette.primary.main,
	},
	fallbackContainer: {
		position: "fixed",
		inset: 0,
		zIndex: 99999,
		backgroundColor: theme.palette.type === 'dark' ? "#1c1c1c" : "#ffffff", // Dinâmico com a App Bar
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "column",
	},
}));

const BackdropLoading = ({ variant = "progress" }) => {
	const classes = useStyles();

	if (variant !== "splash") {
		return (
			<Backdrop className={classes.backdrop} open={true}>
				<CircularProgress color="inherit" />
			</Backdrop>
		);
	}

	return (
		<div className={classes.fallbackContainer}>
			<SplashLoader />
		</div>
	);
};

export default BackdropLoading;
